/** Firestore top-level collection names */
export const COL = {
  USERS: 'users',
  EMPLOYEES: 'employees',
  PROJECTS: 'projects',
  CLIENTS: 'clients',
  INVOICES: 'invoices',
  QUOTATIONS: 'quotations',
  JOBS: 'jobs',
  APPLICANTS: 'applicants',
  MEETINGS: 'meetings',
  PORTFOLIO: 'portfolio',
  ATTENDANCE: 'attendance',
  TASKS: 'tasks',
  LEAVE_REQUESTS: 'leaveRequests',
  APPROVAL_REQUESTS: 'approvalRequests',
  NOTIFICATIONS: 'notifications',
  WEBSITE_SERVICES: 'websiteServices',
  WEBSITE_NEWS: 'websiteNews',
  WEBSITE_PARTNERS: 'websitePartners',
  CONTACTS: 'contacts',
  DOCUMENTS: 'documents',
};

/** Keys on AppContext `data` object → Firestore collection */
export const DATA_KEY_TO_COLLECTION = {
  projects: COL.PROJECTS,
  employees: COL.EMPLOYEES,
  clients: COL.CLIENTS,
  contacts: COL.CONTACTS,
  invoices: COL.INVOICES,
  quotations: COL.QUOTATIONS,
  jobs: COL.JOBS,
  applicants: COL.APPLICANTS,
  meetings: COL.MEETINGS,
  portfolio: COL.PORTFOLIO,
  attendance: COL.ATTENDANCE,
  tasks: COL.TASKS,
  leaveRequests: COL.LEAVE_REQUESTS,
  approvalRequests: COL.APPROVAL_REQUESTS,
  notifications: COL.NOTIFICATIONS,
  websiteServices: COL.WEBSITE_SERVICES,
  websiteNews: COL.WEBSITE_NEWS,
  websitePartners: COL.WEBSITE_PARTNERS,
  documents: COL.DOCUMENTS,
};
